



















































import { Component, Vue, Provide } from "vue-property-decorator";

import BackgroundConfigMobile from "@/components/apps-configuration/tv/bacground-config-mobile.vue";
import LogoConfig from "@/components/apps-configuration/tv/logo-config.vue";
import HelloConfig from "@/components/apps-configuration/tv/hello-config.vue";

import { IConfigurationMobile } from "@/@types/filoxenia-config/tv-config";
import { configuration } from "@/config/host.config";

@Component({
  name: "mobile-configuration",
  components: { BackgroundConfigMobile, LogoConfig, hello: HelloConfig },
})
class MobileConfiguration extends Vue {
  @Provide() bgFolder = "main/configuration/background/mobile";
  @Provide() hello_image_folder = "main/configuration/background/mobile/hello";
  @Provide() logoFolder = "main/configuration/logo/mobile";

  background = "";
  logo = "";
  option_id = "";

  get logoAccess(): boolean {
    return process.env.VUE_APP_CHANGE_LOGO ? true : this.$isRoot();
  }

  async updateConfig(data: Partial<IConfigurationMobile>): Promise<void> {
    try {
      const config = { params: { app: this.$options.name?.split("-")[0] } };
      const configRes = await this.$axios.put(
        configuration.mainAPI,
        data,
        config
      );
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createConfiguration();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  createConfigParams(data: IConfigurationMobile): void {
    this.background = data.background;
    this.logo = data.logo;
  }

  async createConfiguration(): Promise<void> {
    try {
      const config = {
        params: { "match[app]": this.$options.name?.split("-")[0] },
      };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        this.createConfigParams(configRes.data.configurationmobile);
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createConfiguration();
  }
}
export default MobileConfiguration;
